var _module_exports ="<a href=\"{{getUrl()}}\" ng-click=\"navigateTo($event)\" ng-bind=\"visibleText\"></a>";;
var path = '/app/shared/procedure/prcInlineRef.Section.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;